import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Show the BFX brand instead of provider names in user-facing text.
export const brand = (t) => (typeof t === "string" ? t.replace(/\b(?:sume|ltx)(?:\.com|\.io)?(?:(?:-\d+(?:[.-]\d+)*|\s\d+\.\d+)(?:[\s-](?:pro|fast))?)?\b/gi, "BFX") : t);

export const getUnlock = () => {
  try {
    const u = JSON.parse(sessionStorage.getItem("ax_unlock") || "null");
    return u && u.exp > Date.now() ? u.t : null;
  } catch { return null; }
};
export const setUnlock = (t, secs) => (t ? sessionStorage.setItem("ax_unlock", JSON.stringify({ t, exp: Date.now() + secs * 1000 - 5000 })) : sessionStorage.removeItem("ax_unlock"));

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ax_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const unlock = getUnlock();
  if (unlock && config.url?.startsWith("/settings/")) config.headers["X-Settings-Unlock"] = unlock;
  return config;
});

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

// Download any media under an exact file name (e.g. shot_12_actionplate.png).
export const saveAs = async (u, name) => {
  const r = await fetch(mediaUrl(u));
  if (!r.ok) throw new Error("Download failed");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(await r.blob()); a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 30000);
};

export const INR_RATE = 83.5;
export const fmtUSD = (v) => { const n = Number(v || 0); return `$${n.toFixed(n > 0 && n < 0.01 ? 4 : n < 0.1 && n > 0 ? 3 : 2)}`; };
export const fmtINR = (v) => `₹${Number(v || 0).toFixed(2)}`;

export const kindOf = (g, i = 0) => {
  const t = (g?.output_types?.[i] || "").toLowerCase();
  const u = (g?.output_urls?.[i] || "").toLowerCase().split("?")[0];
  if (t.startsWith("video") || /\.(mp4|webm|mov)$/.test(u)) return "video";
  if (t.startsWith("audio") || /\.(mp3|wav|m4a|ogg|aac)$/.test(u)) return "audio";
  if (!u && ["video", "remix"].includes(g?.section)) return "video";
  return "image";
};

export const genDownload = (g, i = 0, shareToken) =>
  `${API}/generations/${g.id}/download?i=${i}&token=${encodeURIComponent(shareToken || "")}`;

const iframeGet = (url) => {
  const f = document.createElement("iframe");
  f.style.display = "none";
  f.src = url;
  document.body.appendChild(f);
  setTimeout(() => f.remove(), 120000);
};

export const isVideoOut = (g, i = 0) => /^video\//.test((g.output_types || [])[i] || "") || /\.(mp4|webm|mov)(\?|$)/i.test((g.output_urls || [])[i] || "");

const FMT_LABEL = { mp4: "MP4 (H.264)", mov: "MOV (ProRes)", png_seq: "PNG sequence", tga_seq: "TGA sequence", cmp_sbs: "Comparison · side by side", cmp_tb: "Comparison · top / bottom" };

// Videos are prepared in the background (works behind the live site's time limit), then downloaded.
export const exportVideos = async (items, fmt = "mp4") => {
  const label = `${FMT_LABEL[fmt] || fmt}${items.length > 1 ? ` · ${items.length} clips stitched` : ""}`;
  const tid = toast.loading(`Preparing ${label}…`, { description: "You can keep working — the download starts by itself." });
  try {
    const { data } = await api.post("/exports", { items, fmt });
    for (let n = 0; n < 900; n++) {
      await new Promise((r) => setTimeout(r, n < 5 ? 1500 : 3000));
      const { data: st } = await api.get(`/exports/${data.id}`);
      if (st.status === "done") { iframeGet(`${BACKEND_URL}${st.url}`); toast.success(`${label} ready`, { id: tid, description: st.filename }); return true; }
      if (st.status === "failed") throw new Error(st.error || "Export failed");
    }
    throw new Error("Export is taking too long");
  } catch (e) {
    toast.error(`Could not prepare ${label}`, { id: tid, description: errMsg(e, e?.message || "Please try again") });
    return false;
  }
};

export const downloadGen = async (g, i = 0, fmt = "mp4") => {
  if (isVideoOut(g, i)) return exportVideos([{ generation_id: g.id, i }], fmt);
  const { data } = await api.get(`/generations/${g.id}/download-link?i=${i}&fmt=${fmt}`);
  iframeGet(`${BACKEND_URL}${data.url}`);
  return true;
};

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  return Array.isArray(d) ? d.map((x) => x?.msg || JSON.stringify(x)).join("; ") : JSON.stringify(d);
};
